import { Injectable } from '@angular/core';
import { Employee } from '../models/Employees';
import { Invite } from '../models/Invite';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { ActionSheetController } from '@ionic/angular';
import { LocalDbService } from './localDb.service';

@Injectable({
    providedIn: 'root'
})
export class WhatsappService {
    baseUrl: string = environment.baseUrl;
    constructor(private localDb: LocalDbService, private auth: AuthService,
        private actionSheetController: ActionSheetController) { }

    sendMessage(phone: string, message: string) {
        message = encodeURIComponent(message);
        if (phone) {
            let cleanPhone = phone.replace(/\D/g, '');
            if (cleanPhone.startsWith('9191') && cleanPhone.length >= 14) {
                cleanPhone = cleanPhone.substring(2);
            }
            if (cleanPhone.length === 10) {
                cleanPhone = '91' + cleanPhone;
            }
            window.open('https://wa.me/' + cleanPhone + '?text=' + message, '_blank');
        } else {
            window.open('https://wa.me/?text=' + message, '_blank');
        }
    }

    reminderToAmForApprove(invite: Invite, emp: Employee) {
        // this.alert.showAlert("Verified Successfully", "Your details are saved successfully. Your request is pending for approval with your Area Manager.", "Send").then(() => {
        //     this.findAreaManger(invite).then((am: Employee) => {
        //         if (am) {
        //             this.sendMessage(am.user.user_pd.mobile,
        //                 "Name: " + emp.user.name +
        //                 "\nGotra: " + emp.user.user_pd.sub_community +
        //                 "\nOrigin: " + emp.user.user_pd.origin_city +
        //                 "\nAddress: " + emp.user.user_pd.permanent_address + " " + emp.user.user_pd.current_address2 +
        //                 "\n\nI have successfully submitted my request please approve my request. For more information please contact me." +
        //                 "\n\n" + this.baseUrl + "/vansh/profile"
        //             );
        //         }
        //     });
        // });
    }


    inviteApproved(invite) {
        this.sendMessage(invite.mobile,
            "Hi " + invite.name +
            "\nYour invite is approved by me, (your Area Manager: " + this.auth.loggedInEmployee.user.name + ")." +
            "\nPlease click on the below link for login and create your Family Tree. Feel free to contact me for any help" +
            "\n\n" + this.baseUrl + "/vansh/family-tree")
    }

    familyInvite(emp: Employee) {
        this.sendMessage(emp.user.user_pd.mobile,
            "Hi " + emp.user.name + " Ji," +
            "\n I have added you in Vanshavali please visit the below link to explore your family." +
            "\n\n" + this.baseUrl + "/register/" + emp.user.user_pd.mobile)
    }

    communityReInvite(invite: Invite) {
        this.sendMessage(invite.mobile,
            "Hi " + invite.name + " Ji," +
            "\n I want to invite you in Vanshavali please visit the below link to explore your family." +
            "\n\n" + this.baseUrl + "/register/" + invite.mobile)
    }

    sendDirectInvite(invite: Invite, language: string, relative: Employee, relation: string, selectedEmp: Employee) {
        let url = this.baseUrl + "/register/" + invite.id;
        let phone = null;
        let message = null;
        if (relative) {
            // let creator = this.supa relative.created_by
            url += "/" + relative.id + " \n\n This link is only for " + relative.user.name + ". Don't share it to anyone else.\n\n";
            phone = relative.user.user_pd.mobile;
            let creator = language == "English" ? "Someone" : "किसी";
            let relationMessage = "";
            if (relative.creator) {
                creator = relative.creator.user.name;
                if (relative.creator.id == this.auth.loggedInEmployee.id) {
                    creator = language == "English" ? "I" : "मैं";
                }
            }

            if (relation) {
                relationMessage = selectedEmp.user.name + " जी के " + relation + " के रूप में"
            }
            message = "🙏 नमस्कार! " + relative.user.name + " जी\n\n" +
                creator + " ने आपको वंशावली में " + relationMessage + " जोड़ा है, कृपया अपना विवरण Verify करें। नीचे दिए गए लिंक पर क्लिक करके.\n\n" + url;

            if (language == "English") {
                if (relation) {
                    relationMessage = "as a " + relation + " of " + selectedEmp.user.name + " Ji "
                }
                message = "Hello " + relative.user.name + " Ji\n\n" +
                    creator + " have added you " + relationMessage + "in Vanshavali, Please verify your details. By clicking below link.\n\n" + url;
            }
        } else {
            message = "🙏 नमस्कार! *" + invite.community + "* के सभी सदस्यों के लिए एक खास निमंत्रण 🌟\n\n" +
                "मैं पिछले कुछ समय से Vanshavali App इस्तेमाल कर रहा हूँ और इसका अनुभव बहुत ही अच्छा और फायदे मंद रहा है। इस ऐप के जरिए हमारे समाज के लोग एक-दूसरे से जुड़ पा रहे हैं और अपनी जड़ों को फिर से जान रहे हैं। 💫यह हमारी संप्रदाय को जोड़ने वाला एक डिजिटल मंच है। 💫\n" +
                "एप से जुड़ने के लिए लिंक क्लिक करें: \n" + url + "\n\n" +

                " 🌟 ऐप की कुछ खास बातें:\n" +
                " 🌿 *डिजिटल वंशावली*, " +
                " 📰 *समाज की ताज़ा खबरें*, " +
                " 🎓 *नेतृत्व पैनल*," +
                " 💼 *नौकरी और व्यापार*,\n" +

                " 📲 आज ही Vanshavali App पर " + invite.community + " से जुड़ें!\n\n" +
                " आइए, मिलकर एक मजबूत और श्रेष्ठ समाज बनाएं।\n\n" +
                "👤 आपका शुभेच्छु: " + invite.name + ",\n " + invite.complete_address + "\n" +
                (invite.remarks ? "📍 " + invite.remarks + "\n" : "");

            if (language == "English") {
                message = "🙏 Namaste! A Special Invitation for All Members of\n" +
                    "🌟  *" + invite.community + "* 🌟\n " +
                    "I’ve been using the Vanshavali App, and it’s been a truly enriching experience! it’s a digital platform that brings our community together.\n" +

                    "Click on the below link to join our community -\n" + url + "\n\n" +

                    "🌟 Key Features You’ll Love:\n" +
                    " 🌿 *Digital Family Tree*," +
                    " 📰 *News Feed*," +
                    " 🎓 *Leadership Panel*," +
                    " 💼 *Jobs & Business Posts*,\n" +

                    " 📲 Join the " + invite.community + " on Vanshavali App and explore your roots!Let’s build a stronger, connected Samaj together!\n\n" +
                    "👤 Yours sincerely : " + invite.name + ",\n " + invite.complete_address + "\n" +
                    (invite.remarks ? "📍 " + invite.remarks + "\n" : "");

            }
        }
        this.sendMessage(phone, message);
    }


    sendDirectInviteOld(invite: Invite, language: string, relative?: Employee) {
        let url = this.baseUrl + "/register/" + invite.id;
        let phone = null;

        if (relative) {
            url += "/" + relative.id + " \n\n This link is only for " + relative.user.name + " Don't share it to anyone else.\n\n";
            phone = relative.user.user_pd.mobile;
        }
        let message = "🙏 नमस्कार! *" + invite.community + "* के सभी सदस्यों के लिए एक खास निमंत्रण 🌟\n\n" +
            "मैं पिछले कुछ समय से Vanshavali App इस्तेमाल कर रहा हूँ और इसका अनुभव बहुत ही अच्छा और फायदे मंद रहा है। इस ऐप के जरिए हमारे समाज के लोग एक-दूसरे से जुड़ पा रहे हैं और अपनी जड़ों को फिर से जान रहे हैं। 💫यह हमारी संप्रदाय को जोड़ने वाला एक डिजिटल मंच है। 💫\n" +
            "एप से जुड़ने के लिए लिंक क्लिक करें: \n" + url + "\n\n" +

            " 🌟 ऐप की कुछ खास बातें:\n" +
            " 🌿 *डिजिटल वंशावली* – अपना पारिवारिक वृक्ष बनाएं और रिश्तेदारों से जुड़ें \n" +
            " 📰 *समाज की ताज़ा खबरें* – विवाह, शुभ कार्य, दुखद समाचार, और अन्य अपडेट्स\n" +
            " 🎓 *नेतृत्व पैनल* – हमारे समाज के पदाधिकारियों की जानकारी एक जगह पर मिल जायेगी। \n" +
            " 💼 *नौकरी और व्यापार* - से जुड़ी पोस्ट्स\n" +

            " 📲 आज ही Vanshavali App पर " + invite.community + " से जुड़ें!\n\n" +
            " आइए, मिलकर एक मजबूत और श्रेष्ठ समाज बनाएं।\n\n" +
            "👤 आपका शुभेच्छु: " + invite.name + ",\n " + invite.complete_address + "\n" +
            (invite.remarks ? "📍 " + invite.remarks + "\n" : "");

        if (language == "English") {
            message = "🙏 Namaste! A Special Invitation for All Members of\n" +
                "🌟  *" + invite.community + "* 🌟\n " +
                "I’ve been using the Vanshavali App, and it’s been a truly enriching experience! It’s more than just an app — it’s a digital platform that’s bringing our community closer than ever.\n" +

                "Click on the below link to join our community -\n" + url + "\n\n" +

                "🌟 Key Features You’ll Love:\n" +
                " 🌿 *Digital Family Tree* – Discover your lineage and connect with long-lost relatives\n" +
                " 📰 *News Feed* – Stay updated with verified community news & achievements\n" +
                " 🎓 *Leadership Panel* – Know your community leaders and their designations\n" +
                " 💼 *Jobs & Business Posts* – Explore opportunities and promote your ventures\n\n" +

                " 📲 Join the " + invite.community + " on Vanshavali App and explore your roots!Let’s build a stronger, connected Samaj together!\n\n" +
                "👤 Yours sincerely : " + invite.name + ",\n " + invite.complete_address + "\n" +
                (invite.remarks ? "📍 " + invite.remarks + "\n" : "");

        }

        this.sendMessage(phone, message);
    }

    async inviteSheet(invite, relative, relation, selectedEmp: Employee) {
        this.localDb.localGet('language').then(async (savedLang) => {
            if (savedLang) {
                if (savedLang == 'en') {
                    this.sendDirectInvite(invite, 'English', relative, relation, selectedEmp)
                } else {
                    this.sendDirectInvite(invite, 'Hindi', relative, relation, selectedEmp)
                }
            } else {
                const actionSheet = await this.actionSheetController.create({
                    header: 'Language to invite member',
                    buttons: [{
                        text: 'Hindi',
                        handler: () => {
                            this.sendDirectInvite(invite, 'Hindi', relative, relation, selectedEmp)
                        }
                    }, {
                        text: 'English',
                        handler: () => {

                            this.sendDirectInvite(invite, 'English', relative, relation, selectedEmp)
                        }
                    }, {
                        text: 'Cancel',
                        handler: () => {
                            console.log('Cancel clicked');
                        }
                    }]
                });

                await actionSheet.present();
            }
        })


    }

}
